<template>
  <div>
    <v-dialog v-model="open" max-width="550px" persistent>
      <template v-slot:activator="{ on, attrs }">
        <v-btn :disabled="useUrl" text color="primary" v-bind="attrs" v-on="on">
          {{ toolbarTitle }}
        </v-btn>
      </template>

      <v-card>
        <v-toolbar flat>
          <v-btn icon @click="open = false">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title>{{ toolbarTitle }}</v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pa-8">
          <location-post-preview no-action :title="title" :summary="summary" :action-button-link="actionButtonLink"
            :action-button-type="actionButtonType" :created-at="createdAt" :alert-type="alertType"
            :event-schedule="eventSchedule" :event-schedule-code="eventScheduleCode" :offer-coupon-code="offerCouponCode"
            :offer-redeem-online-url="offerRedeemOnlineUrl" :offer-terms-and-conditions="offerTermsAndConditions"
            :location-name="locationName" :location-phone="locationPhone" :id="id" :type="type" :open-date="openDate"
            :open-time="openTime" :close-date="closeDate" :close-time="closeTime" :image="image"
            :mediaFormat="mediaFormat" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LocationPostPreview from '@/views/Locations/Components/LocationPostPreview'

export default {
  name: 'LocationPostPreviewModal',
  props: {
    useUrl: Boolean,
    locationName: {
      required: true,
      type: String
    },
    locationPhone: String,
    onUpdated: Function,
    id: Number,
    title: String,
    image: String,
    mediaFormat: String,
    summary: String,
    type: String,
    toolbarTitle: {
      type: String,
      default: 'Visualizar postagem'
    },
    actionButtonType: String,
    actionButtonLink: String,
    createdAt: {
      type: String,
      default: 'postado agora mesmo'
    },
    alertType: String,
    eventSchedule: String,
    eventScheduleCode: String,
    offerRedeemOnlineUrl: String,
    offerCouponCode: String,
    offerTermsAndConditions: String,
    openDate: String,
    openTime: String,
    closeDate: String,
    closeTime: String,
  },
  components: {
    LocationPostPreview
  },
  data: () => ({
    open: false
  })
}
</script>

<style scoped></style>